<template>
  <div class="r-uni-mmask">
    <div
      class="r-uni-mmask"
      @touchmove.stop.prevent="moveHandle"
    />
    <div class="r-moreBack">
        <div class="rs-title">
          交易必读
        </div>
        <img src="@/assets/cgr.png" @click="choosedef"
        alt class="r-tag-icon" v-if="rtype === 0" />
        <img src="@/assets/cin.png" @click="unchoosedef"
        alt class="r-tag-icon" v-if="rtype === 1"/>
        <img src="@/assets/cred.png" @click="choosedef"
        alt class="r-tag-icon" v-if="rtype === 2"/>
        <div class="rs-content">
          继续购买即表示您已仔细阅读并同意 <span
          class="rs-content-xy" @click="xyClick1">风险揭示书</span> 和 <span
          class="rs-content-xy" @click="xyClick2">产品概要</span> 。
        </div>
        <div class="r-cancel-sp-btn linetop">
          <div class="r-cancel-m-btn-sp" @click="cancelhide">取消</div>
          <div class="r-spline"></div>
          <div class="r-cancel-m-btn" @click="comfirmhide">继续购买</div>
        </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'resPop',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    position: {
      type: String,
      // top - 顶部， middle - 居中, bottom - 底部
      default: 'middle',
    },
    mode: {
      type: String,
      default: 'insert',
    },
    msg: {
      type: String,
      default: '',
    },
    h5Top: {
      type: Boolean,
      default: false,
    },
    buttonMode: {
      type: String,
      default: 'bottom',
    },
    list: {
      type: Array,
      default: () => [],
    },
    tabSelected: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isIphoneX: false,
      offsetTop: 0,
      rtype: 0,
    };
  },
  watch: {
    h5Top(newVal) {
      if (newVal) {
        this.offsetTop = 0;
      } else {
        this.offsetTop = 0;
      }
    },
  },
  created() {
    let offsetTop = 0;
    if (!this.h5Top) {
      offsetTop = 0;
    } else {
      offsetTop = 0;
    }
    this.offsetTop = offsetTop;
    this.isIphoneX = false;
  },
  methods: {
    cancelhide() {
      this.$emit('cancelPopup');
      this.hide();
    },
    xyClick1() {
      this.$emit('tipClick');
    },
    xyClick2() {
      this.$emit('tipClick2');
    },
    comfirmhide() {
      if (this.rtype === 0 || this.rtype === 2) {
        this.rtype = 2;
        this.$feedback.showToast({ title: '请阅读并勾选协议', duration: 3000 });
      } else {
        this.$emit('comfirmClick');
        this.hide();
      }
    },
    hide() {
      this.$emit('hidePopup');
    },
    closeMask() {
      if (this.mode === 'insert') {
        this.$emit('hidePopup');
      }
    },
    choosedef() {
      this.rtype = 1;
    },
    unchoosedef() {
      this.rtype = 0;
    },
    moveHandle() {
    },
    clickPopup(item) {
      this.hide();
      this.$emit('clickPopup', item);
    },
  },
};
</script>
<style lang="less">
.r-uni-mmask {
  position: fixed;
  z-index: 888888;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  justify-content: center;
  align-items: center;
  display: flex;
  background-color: rgba(0, 0, 0, 0.0);
}
.r-moreBack{
  position: fixed;
  z-index: 999999;
  top: 30%;
  width: 516px;
  height: 345px;
  display: flex;
  background: #fff;
  border-radius: 24px;
}
.uni-mpopup {
  // display: grid;
  // grid-template-columns: 25% 25% 25% 25%;
  // z-index: 999;
  // background-color: #ffffff;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding-bottom: 60px;
}
.item-more-button {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1;
    position: relative;
  }

  .item-more-button-icon {
    width: 88px;
    height: 88px;
    border-radius: 50%;
    background: #f5f5f5;
    border: 8px solid #f5f5f5;
    margin-top: 60px;
  }

  .item-more-button-label {
    font-family: PingFangSC-Regular;
    font-size: 24px;
    color: #333333;
    text-align: center;
    line-height: 24px;
    margin-top: 20px;
  }
.itemmorereddot1 {
    background: #FF6435;
    position: absolute;
    border: 2px solid #fff;
    top: 30px;
    right: 20px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 0px;
    // letter-spacing: 0;
    padding: 4px 4px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .itemmoreredpoint{
    height: 10px;
    width: 10px;
    background: #ff4400;
    position: absolute;
    right: 60px;
    top: 62px;
    border-radius: 5px;
  }
  .item-more-red{
    max-width: 150px;
    line-height: 30px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    font-size: 22px;
    color: #ffffff;
  }
.btn {
  width: 25%;
  font-size: 30px;
  text-align: center;
  border-bottom: 0px solid #eeeeee;
}
.r-cancel-sp-btn {
  position: relative;
  display: flex;
  width: 100%;
  background: #fff;
  justify-content: space-between;
}
.r-cancel-m-btn {
  line-height: 88px;
  width: 49%;
  height: 88px;
  font-size: 36px;
  text-align: center;
  background-color: #ffffff;
  color: #FF4400;
  border-radius: 24px;
}
.r-cancel-m-btn-sp {
  border-radius: 24px;
  line-height: 88px;
  width: 49%;
  height: 88px;
  font-size: 36px;
  text-align: center;
  background-color: #ffffff;
}
.rs-title {
  height: 36px;
  font-size: 36px;
  color: #333333;
  text-align: center;
  line-height: 36px;
  padding-top: 40px;
}
.rs-content {
  padding-top: 40px;
  padding-left: 70px;
  padding-right: 30px;
  font-size: 28px;
  color: #333333;
  line-height: 50px;
  color: #000;
  height: 140px;
}
.rs-content-xy {
  color: #008AFF;
}
.r-spline{
  background: #EEEEEE;
  width: 1px;
  height: 88px;
}
.r-tag-icon {
  position: absolute;
  top: 128px;
  left: 30px;
  width: 28px;
  height: 28px;
  margin-right: 5px;
  align-items: center;
}
</style>
